'use client'

import { Polyline, type PolylineProps } from '@react-google-maps/api'
import { useEffect, useState } from 'react'

import { useMapContext } from './context.tsx'
import { decodePath } from './decode-path.ts'

export const Directions = ({ ...arg }: PolylineProps) => {
  const { getRoute, route, setEstimatedTrip } = useMapContext()

  const [directionsResponse, setDirectionsResponse] = useState<
    Array<{
      lat: number
      lng: number
    }>
  >([])

  useEffect(() => {
    const update = async () => {
      if (!route) {
        setDirectionsResponse([])

        return
      }

      const newRoute = route
        .map((data, i) => route[i + 1] && `${data};${route[i + 1]}`)
        .filter(x => x)

      const response = await getRoute(newRoute)

      if (response) {
        setEstimatedTrip(response.total)
        const routesData = response.routes
          .map(({ steps }) => steps.map(step => decodePath(step.polyline.points)).flat())
          .flat()
        setDirectionsResponse(routesData)
      }
    }

    update()
  }, [route])

  return (
    <Polyline
      {...arg}
      options={{
        strokeColor:
          process.env.NEXT_PUBLIC_SOURCE === 'cargoking-shipper' ? '#379ef9' : 'hsl(356,100%,40%)',
        strokeOpacity: 1,
        strokeWeight: 4,
      }}
      path={directionsResponse}
    />
  )
}
